import { getHostname } from './location';

export const getLogoImage = (env?: string): string => {
  const isProd = getHostname().includes('fabfitfun.com');
  const envName = env || (isProd ? 'prod' : 'dev');
  const envURL = envName === 'prod' ? 'fabfitfun.com' : 'fff-dev.com';
  return `https://scontent01.${envURL}/homepage/cdn/fff-seasonal-logo.png`;
};
